import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { ReactComponent as RunIcon } from 'new/components/icons/fi-rr-play.svg';
import { ReactComponent as HelpIcon } from 'new/components/icons/fi-rr-interrogation.svg';
import { useApiServerHelp } from '../../components/ExpandActions/context/ApiServerHelpContext';
import styles from './Request.module.scss';

interface RequestActionsProps {
  onTest: () => void;
  data?: any;
}

export const RequestActions = (props: RequestActionsProps) => {
  const { onTest, data } = props;
  const { openPortal } = useApiServerHelp();

  const handleHelpClick = () => {
    openPortal(data);
  };

  return (
    <div className={styles.requestActions}>
      <Tooltip title="Test Request">
        <IconButton>
          <RunIcon onClick={onTest} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Documentation & cURL">
        <IconButton onClick={handleHelpClick}>
          <HelpIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};
